type Entries<T> = {
  [K in keyof T]: [K, T[K]];
}[keyof T][];


/**
 * Type-safe wrapper around Object.entries
 * @see https://www.charpeni.com/blog/properly-type-object-keys-and-object-entries
 * @see https://stackoverflow.com/questions/60141960/typescript-key-value-relation-preserving-object-entries-type
 * @param {object} obj - The object to get the key/values of as an array
 */
const getEntries = <T extends object>(obj: T) => Object.entries(obj) as Entries<T>;

export default getEntries;
